<template>
  <v-container>
    <v-layout row>
      <v-flex
        xs12
        sm6
        offset-sm3
      >
        <v-card-text>
          <v-container>
            <h2>Class History for {{ decodedEmail }} </h2>
            <p>{{ attendanceForDancer }}</p>
          </v-container>
        </v-card-text>
      </v-flex>
    </v-layout>
  </v-container>
</template>

<script>
  export default {
    props: ['email'],
    computed: {
      decodedEmail () {
        return decodeURIComponent(this.email)
      },
      attendanceForDancer () {
        return this.$store.getters.loadedAttendanceForCurrentDancer.map(item => {
          return item.balletClassName
        }).join(', ')
      }
    },
    created () {
      if (this.$route.query.embed) {
        this.$store.commit('setLayout', 'embed-layout')
      }
      this.$store.dispatch('logDancerInByEmail', this.decodedEmail).then(() => {
        this.$store.dispatch('loadAttendanceForCurrentDancer')
      })
    }
  }
</script>
